// extracted by mini-css-extract-plugin
export default {"nav":"nav__1wcie"};